/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParticipantStatusDto } from '../models/ParticipantStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantStatusControllerService {

    /**
     * Check status of a participant
     * @param name
     * @param port
     * @returns ParticipantStatusDto OK
     * @throws ApiError
     */
    public static getParticipantHealthStatus(
        name: string,
        port: number = 5019,
    ): CancelablePromise<ParticipantStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/status',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
